import { useEffect, useRef, useState } from "react";

declare const bootstrap: any;

export default function PreviewModal({ open = false, onClose, html }: any) {
  const modalRef = useRef<HTMLDivElement>(null);
  const [modal, setModal] = useState<any>(null);

  useEffect(() => {
    if (open) {
      modal.show();
    } else {
      if (modal) {
        modal.hide();
      }
    }
  }, [open]);

  useEffect(() => {
    if (modalRef.current) {
      const modalInstance = new bootstrap.Modal(modalRef.current, {});
      setModal(modalInstance);

      modalRef.current.addEventListener('hidden.bs.modal', _ => onClose() )
    }
  }, [modalRef]);

  return (
    <div
      className="modal fade"
      ref={modalRef}
      tabIndex={-1}
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-xl" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Vista previa</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="row" style={{ height: "calc(100vh - 300px)", overflow: "scroll" }}>
              <div
                dangerouslySetInnerHTML={{
                  __html: html ?? ''
                }}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-soft-primary btn-sm"
              onClick={() => modal.hide()}
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
